import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-and-restaurant',
  templateUrl: './hotel-and-restaurant.component.html',
  styleUrls: ['./hotel-and-restaurant.component.scss']
})
export class HotelAndRestaurantComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
